import React from 'react';
import MainCard from 'components/MainCard';
import Typography from '@mui/material/Typography';

export default function Privacy() {
  return (
    <MainCard title="Privacy Policy">
      <Typography variant="body1" color="text.secondary">
        This is a placeholder Privacy Policy page. Add your data collection and usage policies here.
      </Typography>
    </MainCard>
  );
}


